'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Theme$PvpcontrollerWeb = require("../Theme.js");

var prompt = Curry._1(Css.style, {
      hd: Css.position(Css.fixed),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100.0
              }),
          tl: {
            hd: Css.top("zero"),
            tl: {
              hd: Css.right("zero"),
              tl: {
                hd: Css.bottom("zero"),
                tl: {
                  hd: Css.left("zero"),
                  tl: {
                    hd: Css.background(Css.rgba(0, 0, 0, {
                              NAME: "num",
                              VAL: 0.5
                            })),
                    tl: {
                      hd: Css.display("flex"),
                      tl: {
                        hd: Css.alignItems(Css.center),
                        tl: {
                          hd: Css.flexDirection(Css.column),
                          tl: {
                            hd: Css.zIndex(1),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var panel = Curry._1(Css.style, {
      hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
      tl: {
        hd: Css.paddingLeft(Css.px(100)),
        tl: {
          hd: Css.paddingRight(Css.px(100)),
          tl: {
            hd: Css.paddingBottom(Css.px(20)),
            tl: {
              hd: Css.marginTop({
                    NAME: "percent",
                    VAL: 18.0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var text = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.textColor),
      tl: {
        hd: Css.fontSize(Css.px(18)),
        tl: {
          hd: Css.marginBottom(Css.px(20)),
          tl: /* [] */0
        }
      }
    });

var button = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex("282b2f")),
      tl: {
        hd: Css.border(Css.px(0), Css.solid, Css.hex("000")),
        tl: {
          hd: Css.color(Css.hex("797c82")),
          tl: {
            hd: Css.fontSize(Css.px(20)),
            tl: {
              hd: Css.margin(Css.px(10)),
              tl: {
                hd: Css.padding(Css.px(10)),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

function EditModePrompt(Props) {
  var setEditMode = Props.setEditMode;
  var setShowingEditPrompt = Props.setShowingEditPrompt;
  return React.createElement("div", {
              className: prompt
            }, React.createElement("div", {
                  className: panel
                }, React.createElement("h2", {
                      className: Theme$PvpcontrollerWeb.title
                    }, "Do you want to enable edit mode?"), React.createElement("p", {
                      className: text
                    }, "This will allow you to edit settings and stats for weapons and projectiles. Your changes will be kept track of in a temporary changelog. You can exit out of edit mode once you are finished to save the changes permanently or roll them back."), React.createElement("button", {
                      className: button,
                      onClick: (function (param) {
                          Curry._1(setEditMode, (function (_previousState) {
                                  return /* Enabled */1;
                                }));
                          return Curry._1(setShowingEditPrompt, (function (_previousState) {
                                        return false;
                                      }));
                        })
                    }, "Enable"), React.createElement("button", {
                      className: button,
                      onClick: (function (e) {
                          return Curry._1(setShowingEditPrompt, (function (_previousState) {
                                        return false;
                                      }));
                        })
                    }, "Cancel")));
}

function makeProps(prim0, prim1, prim2, prim3) {
  var tmp = {
    setEditMode: prim0,
    setShowingEditPrompt: prim1
  };
  if (prim2 !== undefined) {
    tmp.key = prim2;
  }
  return tmp;
}

var make = EditModePrompt;

exports.makeProps = makeProps;
exports.make = make;
/* prompt Not a pure module */
